import { axios } from "lib/axios";

export const forgotPasswordFn = (
  email: string,
  callback: (response: any | Error) => void
): Promise<any> => {
  return axios
    .post("/auth/forgot_password", email)
    .then((res: any) => {

      const userData = res;

      callback(userData);
      return res.data;
    })
    .catch((err) => {
      callback(err);

      return err;
    });
};
